import React from "react";
import { useInView } from "react-intersection-observer";
// Mac-specific icons (added to DownloadMac/Assets)
import mail from "./Assets/Mail.png";
import slack from "./Assets/Slack.png";
import safari from "./Assets/Safari.png";
import notion from "./Assets/Notion.png";
import notes from "./Assets/Notes.png";
// Reused from the Windows page assets
import gmail from "../DownloadWindow/Assets/gmail.png";
import wApp from "../DownloadWindow/Assets/wApp.png";
import LN from "../DownloadWindow/Assets/LN.png";
import chrome from "../DownloadWindow/Assets/chrome.png";
import word from "../DownloadWindow/Assets/word.png";

const apps = [
  { icon: mail, title: "Apple Mail", desc: "Write emails faster" },
  { icon: gmail, title: "Gmail", desc: "Compose with your voice" },
  { icon: wApp, title: "WhatsApp", desc: "Send messages without typing" },
  { icon: slack, title: "Slack", desc: "Reply to your team instantly" },
  { icon: LN, title: "LinkedIn", desc: "Write posts and messages faster" },
  { icon: safari, title: "Safari", desc: "Search and write naturally" },
  { icon: notion, title: "Notion", desc: "Capture ideas instantly" },
  { icon: notes, title: "Apple Notes", desc: "Turn thoughts into notes" },
  { icon: word, title: "Microsoft Word", desc: "Create documents effortlessly" },
  { icon: chrome, title: "Chrome", desc: "Browse and communicate hands-free" },
];

const stripIcons = [mail, gmail, wApp, slack, LN, safari, notion, notes, word, chrome];

const AppsSection = () => {
  const { ref: headRef, inView: headView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  const { ref: gridRef, inView: gridView } = useInView({
    triggerOnce: true,
    threshold: 0.15,
  });
  return (
    <section className="w-full max-w-[1180px] mx-auto md:px-7 px-4 flex flex-col gap-8">
      <div
        ref={headRef}
        className={`${headView ? "animate-slideUp z-[3] anim-preserve" : "opacity-0 z-0"
          } flex flex-col gap-3 items-center`}
      >
        <h2 className="font-jakarta font-extrabold text-[#0F1B2D] text-center text-[2.625rem] md:text-[2.4rem] lg:text-[2.8rem] xl:text-[3.125rem] leading-[1.24] tracking-[-0.02em]">
          One voice. Every{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]">
            Mac app.
          </span>
        </h2>
        <p className="font-inter font-normal text-[#33425A] text-center text-[1.313rem] md:text-[1.15rem] lg:text-[1.2rem] xl:text-[1.438rem] leading-[1.5] max-w-[680px]">
          Zero Typing works wherever you type on your Mac, from emails and
          documents to messages, browsers, and social media.
        </p>
      </div>

      {/* App icon strip - desktop only (hidden on mobile) */}
      <div className="hidden md:flex justify-center -mt-2">
        <div
          className="w-full max-w-[560px] flex items-center justify-between gap-2 rounded-2xl px-4 sm:px-5 py-3"
          style={{ background: "#EDF5FE" }}
        >
          {stripIcons.map((src, i) => (
            <img
              key={i}
              src={src}
              alt=""
              aria-hidden="true"
              className="w-8 h-8 object-contain shrink-0"
            />
          ))}
        </div>
      </div>

      <div ref={gridRef} className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {apps.map((a, i) => (
          <div
            key={i}
            style={{ animationDelay: `${i * 80}ms` }}
            className={`${gridView ? "animate-scaleIn z-[3] anim-preserve" : "opacity-0 z-0"
              } bg-[#F9F9F9] border border-[#0000000D] rounded-2xl p-3.5 flex items-center gap-2.5`}
          >
            <img
              src={a.icon}
              alt={a.title}
              className="w-8 h-8 object-contain shrink-0"
            />
            <div className="flex flex-col min-w-0">
              <span className="font-inter font-semibold text-[#0F1B2D] text-[0.8125rem] leading-tight">
                {a.title}
              </span>
              <span className="font-inter font-normal text-[#33425A] text-[0.6875rem] leading-tight mt-0.5">
                {a.desc}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AppsSection;
